<template>
	<div>
		<h1 v-if="level === '1'" class="Heading" :class="classes" v-bind="$attrs">
			<a v-if="href" :href="href">
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this slot for the main heading -->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this slot for the sub heading -->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this slot as an alternative -->
					<slot />
				</template>
			</a>
			<template v-else>
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative for a sub-->
					<slot />
				</template>
			</template>
		</h1>
		<h2 v-if="level === '2'" class="Heading" :class="classes" v-bind="$attrs">
			<a v-if="href" :href="href">
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</a>
			<template v-else>
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</template>
		</h2>
		<h3 v-if="level === '3'" class="Heading" :class="classes" v-bind="$attrs">
			<a v-if="href" :href="href">
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</a>
			<template v-else>
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for the an alternative sub-->
					<slot />
				</template>
			</template>
		</h3>
		<h4 v-if="level === '4'" class="Heading" :class="classes" v-bind="$attrs">
			<a v-if="href" :href="href">
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</a>
			<template v-else>
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</template>
		</h4>
		<h5 v-if="level === '5'" class="Heading" :class="classes" v-bind="$attrs">
			<a v-if="href" :href="href">
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</a>
			<template v-else>
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for the alternative sub-->
					<slot />
				</template>
			</template>
		</h5>
		<h6 v-if="level === '6'" class="Heading" :class="classes" v-bind="$attrs">
			<a v-if="href" :href="href">
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</a>
			<template v-else>
				<template v-if="sub">
					<span class="Heading-main" :class="mainClasses">
						<!-- @slot Use this for the main heading-->
						<slot />
					</span>
					<span class="Heading-sub" :class="subClass">
						<!-- @slot Use this for the sub heading-->
						<slot name="sub" />
					</span>
				</template>
				<template v-else>
					<!-- @slot Use this for an alternative sub-->
					<slot />
				</template>
			</template>
		</h6>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	data() {
		return {};
	},
	props: {
		/**
		 * Level of the heading: h1 - h6: 1, 2, 3, 4, 5, 6
		 */
		level: {
			type: String,
			default: '1',
		},
		/**
		 * Size override (make an h1 look like an h3): 1, 2, 3, 4, 5, 6
		 */
		size: {
			type: String,
			default: null,
		},
		/**
		 * reverse
		 */
		reverse: {
			type: Boolean,
			default: false,
		},
		/**
		 * style for a minor heading (less emphasis)
		 */
		minor: {
			type: Boolean,
			default: false,
		},
		/**
		 * style for a subheading (meant to go after a main heading)
		 */
		subheading: {
			type: Boolean,
			default: false,
		},
		/**
		 * heading and subheading on the same line
		 */
		inline: {
			type: Boolean,
			default: false,
		},
		/**
		 * styles a heading with a link as if it was not a link
		 * TODO: deprecate?
		 */
		hiddenLink: {
			type: Boolean,
			default: false,
		},
		/**
		 * styles the subheading in italics (for Scientific names)
		 */
		subSci: {
			type: Boolean,
			default: false,
		},
		/**
		 * disables other subheading styles?
		 */
		custom: {
			type: Boolean,
			default: false,
		},
		/**
		 * Heading styles: None, but prop is available for utility classes
		 */
		utilityClasses: {
			type: String,
			default: null,
		},
		/**
		 * Heading-main styles: None, but prop is available for utility classes
		 */
		mainClasses: {
			type: String,
			default: null,
		},
		/**
		 * Heading-sub styles: None, but prop is available for utility classes
		 */
		subClasses: {
			type: String,
			default: null,
		},
		/**
		 * If set, makes the heading link to a URL
		 */
		href: {
			type: String,
			default: null,
		},
	},
	computed: {
		classes() {
			const classes = {
				'Heading--reverse': this.reverse,
				'Heading--minor': this.minor,
				'Heading--hiddenLink': this.hiddenLink,
				'Heading--sub': this.subheading,
			};
			if (this.size) {
				classes['Heading--h' + this.size] = true;
			}
			if (this.utilityClasses) {
				this.utilityClasses.split(' ').forEach((item) => {
					classes[item] = true;
				});
			}
			return classes;
		},
		subClass() {
			const subClasses = this.subClasses;
			return {
				'Heading-sub--inline': this.inline,
				'Heading-sub--sci': this.subSci,
				'Heading-sub--custom': this.custom,
				subClasses,
			};
		},
		sub() {
			return !!this.$slots.sub;
		},
	},
};
</script>

<style lang="scss">

/* --------------------------------
	Base classes
-------------------------------- */

// Heading
.Heading {
	@include heading;
	color: $color-black;
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	a {
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
	}
	span:not(:last-child) {
		margin-right: $space-rel-sm;
		[dir='rtl'] & {
			margin-right: 0;
			margin-left: $space-rel-sm;
		}
	}
	// h1 override
	&.Heading--h1 {
		@include h1;
	}
	// h2 override
	&.Heading--h2 {
		@include h2;
	}
	// h3 override
	&.Heading--h3 {
		@include h3;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
			'Helvetica Neue', sans-serif;
	}
	// h4 override
	&.Heading--h4 {
		@include h4;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
			'Helvetica Neue', sans-serif;
	}
	// h5 override
	&.Heading--h5 {
		@include h5;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
			'Helvetica Neue', sans-serif;
	}
	// h6 override
	&.Heading--h6 {
		@include h6;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
			'Helvetica Neue', sans-serif;
	}
	// Subheading
	&.Heading--sub {
		@include heading-sub;
	}
}

// Main heading (optional span for main and sub relationship)
.Heading-main {
	flex: 0 1 auto;
}

// Subheading (optional span for main and sub relationship)
.Heading-sub,
.Heading > em,
.Heading > a > em {
	@include heading-sub;
	flex: 0 1 100%;
	h1 &,
	.Heading.Heading--h1 & {
		&:not(.Heading-sub--custom) {
			margin-top: $space-xs;
			@include text(5);
			@include headingSubAvenir;
			@include breakpoint(medium) {
				@include text(6);
			}
		}
	}
	h2 &,
	.Heading.Heading--h2 & {
		&:not(.Heading-sub--custom) {
			margin-top: $space-xs;
			@include text(4);
			@include headingSubAvenir;
			@include breakpoint(medium) {
				@include text(5);
			}
		}
	}
	h3 &,
	.Heading.Heading--h3 & {
		&:not(.Heading-sub--custom) {
			margin-top: $space-xxs;
			@include text(4);
		}
	}
	h4 &,
	.Heading.Heading--h4 & {
		&:not(.Heading-sub--custom) {
			margin-top: $space-xxs;
			@include text(3);
		}
	}
	h5 &,
	.Heading.Heading--h5 & {
		&:not(.Heading-sub--custom) {
			@include text(2);
		}
	}
	h6 &,
	.Heading.Heading--h6 & {
		&:not(.Heading-sub--custom) {
			@include text(1);
		}
	}
	// Heading-sub--inline variant for inline subheadings
	&--inline {
		display: inline;
		flex: 0 1 auto;
	}
	// Heading-sub--sci variant for itallicising scientific names
	&--sci {
		font-style: italic;
	}

	// sci for eBird species name output
	&.sci {
		display: inline;
		flex: 0 1 auto;
		font-style: italic;
		margin-left: $space-sm;
		[dir='rtl'] & {
			margin-left: 0;
			margin-right: auto;
		}
	}
}

// Optional icon child of heading
.Heading-icon {
	display: flex;
	align-self: center;
	h1 &,
	.Heading.Heading--h1 &,
	h2 &,
	.Heading.Heading--h2 & {
		.Icon {
			@include icon-lg;
		}
	}
	h3 &,
	.Heading.Heading--h3 &,
	h4 &,
	.Heading.Heading--h4 & {
		.Icon {
			@include icon-md;
		}
	}
	h5 &,
	.Heading.Heading--h5 &,
	h6 &,
	.Heading.Heading--h6 & {
		.Icon {
			@include icon-sm;
		}
	}
}

/* --------------------------------
	Variants
-------------------------------- */

// Reverse variant - for dark backgrounds
.Heading--reverse {
	color: $color-white;
	a {
		color: $color-link-reverse;
		&:hover,
		&:focus,
		&:active {
			color: $color-link-hover-reverse;
		}
	}
	&.Heading--sub {
		color: $color-neutral-2;
	}
	.Heading-sub {
		color: $color-neutral-2;
	}
}

// Minor variant - makes heading lighter, uppercase.
.Heading--minor {
	color: $color-neutral-4;
	text-transform: uppercase;
	&.Heading--reverse {
		color: $color-neutral-2;
	}
	.Heading-sub {
		text-transform: normal;
	}
}

// Hidden link variant - removes link color from linked heading
.Heading--hiddenLink {
	a {
		color: $color-black;
		&:hover,
		&:focus,
		&:active {
			color: $color-black;
		}
	}
	&.Heading--reverse {
		a {
			color: $color-white;
			&:hover,
			&:focus,
			&:active {
				color: $color-white;
			}
		}
	}
}
</style>
